import { render } from "./stars.vue?vue&type=template&id=fac2b734&scoped=true&ts=true"
import script from "./stars.vue?vue&type=script&lang=ts"
export * from "./stars.vue?vue&type=script&lang=ts"

import "./stars.vue?vue&type=style&index=0&id=fac2b734&scoped=true&lang=css"

import exportComponent from "C:\\projects\\totalrender\\onofficeapp\\marketplaceapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fac2b734"]])

export default __exports__